import { ROUTE } from '@/types';
export var EnvRegion;
(function (EnvRegion) {
    EnvRegion[EnvRegion["eu"] = 1] = "eu";
    EnvRegion[EnvRegion["us"] = 2] = "us";
    EnvRegion[EnvRegion["cn"] = 3] = "cn";
})(EnvRegion || (EnvRegion = {}));
export var EnvType;
(function (EnvType) {
    EnvType["INT"] = "int";
    EnvType["LOCAL"] = "local";
    EnvType["PROD"] = "prod";
    EnvType["VAL"] = "val";
})(EnvType || (EnvType = {}));
const ENV_URLS = {
    [EnvType.INT]: 'trial.int.umotif.io',
    [EnvType.LOCAL]: 'li0031.local.umotif.io:3000',
    [EnvType.PROD]: 'trial.umotif.io',
    [EnvType.VAL]: 'trial.val.umotif.io'
};
// Set when the dev server proxies API requests (`pnpm dev:api`, uBob)
const isAPIProxied = Boolean(process.env.API_PROXY_TARGET);
/**
 * Returns the environment name based on the current host
 * a dev server proxying the API is local on any host
 */
export const getEnvConfig = (host) => {
    var _a;
    if (host === void 0) { host = (_a = window.location.host) !== null && _a !== void 0 ? _a : ''; }
    const entry = Object.entries(ENV_URLS).find(([, url]) => url === host);
    const ENV_NAME = isAPIProxied ? EnvType.LOCAL : entry ? entry[0] : EnvType.PROD;
    return {
        ENV_NAME
    };
};
export const localAPIUrl = isAPIProxied ? window.location.origin : 'https://li003-eu.int.umotif.io';
export const isProd = getEnvConfig().ENV_NAME === EnvType.PROD;
export const isLocal = getEnvConfig().ENV_NAME === EnvType.LOCAL;
export const isPreview = window.location.pathname.includes(ROUTE.QUESTIONNAIRE_BUILDER_PREVIEW);
